<template>
  <div class="project">
    <div v-if="project !== null">
      <div class="d-md-block d-none">
        <div class="container-top container-top-project" :style="'background-image: url(' +project.top_image.desktop+ ');'"></div>
      </div>
      <div class="d-md-none d-block">
        <div class="container-top container-top-project" :style="'background-image: url(' +project.top_image.mobile+ ');'"></div>
      </div>
      <div class="container content-project position-relative pb-5">
        <b-row>
          <b-col lg="8" md="10">
            <h3 class="section-title line-up-dark d-inline-block">
              {{project.name}}
            </h3>
            <p>{{project.text}}</p>
            <b-row class="mt-4">
              <b-col cols="12" class="text-left">
                <b-row>
                  <b-col v-for="(item, idx) in project.icons" :key="idx" sm="3" cols="4">
                    <div class="text-center" v-if="typeof item.href !== 'undefined'">
                      <a :href="item.href" class="icon-link" target="_blank">
                        <p class="d-inline-block"><img :src="item.img" alt="Icon"><br>
                        <span v-html="item.description"></span></p>
                        &nbsp;
                        <img class="align-middle position-relative know-more d-none d-sm-inline" src="../assets/images/ClickMaisProjeto.png" alt="icon">
                      </a>
                    </div>
                  
                    <div v-else class="text-center">
                      <img :src="item.img" alt="Icon">
                      <p v-html="item.description">
                      </p>
                    </div>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="4">

            <div class="ml-lg-5">
            
              <div>
                <h3 class="section-title line-up-dark d-inline-block">
                    {{project.dinamic_title}}:
                  </h3>
                  <p v-html="project.description" class="desc-block"></p>
              </div>
              <!--  

              <div class="mt-4">
                  <h3 class="section-title line-up-dark d-inline-block">
                    {{configs['availability']}}:
                  </h3>
                  <p v-html="project.availability"></p>
                  <a v-if="typeof project.availability_hrefs !== 'undefined'" v-for="(anchor, idx) in project.availability_hrefs" :href="anchor.href" :key="idx" class="availability-link icon-link d-block" target="_blank">
                    <span class="align-middle">{{anchor.text}}</span>
                    &nbsp;
                    <img class="align-middle position-relative know-more" src="../assets/images/ClickMaisProjeto.png" alt="icon">
                  </a>
              </div>
              -->

            </div>

          </b-col>
        </b-row>
      </div>
      <div class="container mb-5 space-to-footer">
        <b-row>
          <b-col cols="12">
            <Slider v-if="render_slider" v-bind:items="project.slider_images" v-bind:settings="slider_settings" v-bind:page="'project'"></Slider>
          </b-col>
        </b-row>
      </div>
      <!-- <div class="container pt-5 mt-5 space-to-footer">
       <b-row>
          <b-col cols="12" class="text-center pt-5">
            <div class="related-up-line mb-2 mx-auto"></div>
            <h3 class="section-title">
              {{configs['related_projects_txt']}}
            </h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="10" offset-md="1" class="text-center mt-5">
            <b-row>
              <b-col md="4" v-for="(item, idx) in related_projects" :key="idx" class="text-center mt-3 mt-md-0">
                <router-link :to="{name: 'project', params: {lang: $route.params.lang, id: item.id, slug: item.slug}}" class="related-link">
                    <div class="position-relative" :style="'background-image: url(' +item.thumbnail+ ');'">
                      <div class="overlay-thumb text-center w-100 h-100 position-absolute text-center p-3">
                        <div class="position-relative text-center w-100">
                          <h4 class="section-title line-up-white text-white d-inline-block">{{item.abreviature}}</h4>
                          <p class="text-white">{{item.teaser}}</p>
                        </div>
                      </div>
                    </div>
                </router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div> -->
    </div>
   <Footer v-if="project !== null"></Footer>
  </div>
</template>
<script>
import Slider from '@/components/Slider.vue'

export default {
  components: {
    Slider
  },
  data() {
    return {
      project: null,
      projects: this.configs['projects'],
      render_slider: false,
      slider_settings: {
        initialSlide: 0, // here to be compatible with other components using slide
        main: {
          infiniteScroll: true,
          initialSlide: 0,
          transition: 500,
          mouseDrag: false,
          shortDrag: false, // so it won't slide on mobile screen just by touching it
          wheelControl: false,
        },
        synced: {
          mouseDrag: false,
          transition: 600,
          wheelControl: false,
          initialSlide: 0,
          infiniteScroll: true,
          centerMode: true,
          breakpoints: {
            0: {
              itemsToShow: 3
              // centerMode: false,
              // pagination: 'indicator'
            },
            991.98: {
              itemsToShow: 5
              // pagination: 'fraction'
            },
            1200: {
              itemsToShow: 7
            }
          }
        },
      }
    }
  },
  watch: {
    project: function(new_val, old_val) {
      this.slider_settings.initialSlide = new_val.initial_slide;
      this.slider_settings.main.initialSlide = new_val.initial_slide;
      this.slider_settings.synced.initialSlide = new_val.initial_slide;
      this.render_slider = true;
    }
  },
  computed: {
    related_projects: function(){
      /*let rel_projs = [];
      for(let i=0; i < this.projects.length; i++) {
        for(let j=0; j < this.projects[i].categories.length; j++) {
          if(this.project.categories.indexOf(this.projects[i].categories[j]) !== -1) {
            rel_projs.push(this.projects[i]);
            break;
          }
        }
      }*/
      return this.projects.filter((item, idx) => this.project.related_projects.indexOf(item.id) !== -1);
    }
  },
  created: function() {
    let project = this.configs['projects'].find((item, idx) => item.id == this.$route.params.id);
    if(typeof project === 'undefined') {
      this.$router.replace(this.$route.path+ '/404');
    }
    else {
      this.project = project;
      document.title = document.title+ ' ' +this.project.tab_title;
    }
    // this.$router.replace({name: 'project', params: {lang: this.$route.params.lang, key: this.$route.params.key, slug: this.project.slug}});
  }
}
</script>
<style scoped>
a.related-link {
}
a.related-link > div {
  height: 200px; 
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.overlay-thumb {
  transition: all 0.25s ease-in-out;
  background-color: rgba(0, 0, 0, .5);
  opacity: 0;
}
.overlay-thumb > div {
  top: 60%;
  transform: translateY(-50%);
  transition: all 0.25s ease-in-out;
}
a.related-link:hover .overlay-thumb {
  opacity: 1;
}
a.related-link:hover .overlay-thumb > div {
  top: 50%;
}
.container-top.container-top-project {
  min-height: 700px;
}
.related-up-line {
  background-color: #00263d;
  width: 220px;
  height: 4px;
}
/*.icons-desc {
  width: 25%;
}*/
a.icon-link, .desc-block >>> a { /* deep selectos, https://medium.com/@brockreece/scoped-styles-with-v-html-c0f6d2dc5d8e*/
  color: inherit;
}
a.icon-link:hover {
  text-decoration: none;
}
a.icon-link:hover span, .desc-block >>> a:hover { /* deep selectos, https://medium.com/@brockreece/scoped-styles-with-v-html-c0f6d2dc5d8e*/
  text-decoration: underline;
}
a.icon-link img.know-more {
  transition: all 0.25s ease-in-out;
  bottom: 1px;
}
a.icon-link:hover img.know-more {
  transform: rotate(180deg);
}
.content-project {
  margin-top: -260px;
}
a.availability-link {
  color: inherit;
}
a.availability-link:hover {
  text-decoration: none;
}
a.availability-link:hover span {
  text-decoration: underline;
}
.related-link h3 {
  bottom: 0;
  left: 0;
}

@media screen and (max-width:991.98px) {
  .overlay-thumb {
    opacity: 1;
  }
  .overlay-thumb > div {
    top: 50%;
  }
  .icons-desc {
    width: 33.33%;
  }
}
</style>